import React from "react";
import searchIcon from "../../Assets/img/icons/Search.svg";

type BlogNoResultsProps = {
  onReset?: () => void;
};

const BlogNoResults = ({ onReset }: BlogNoResultsProps) => (
  <section className="blog-empty-state" aria-live="polite">
    <div className="blog-empty-state__card">
      <div className="blog-empty-state__icon" aria-hidden="true">
        <img src={searchIcon} alt="" width={40} height={40} />
      </div>
      <h2 className="blog-empty-state__title">No articles match your filters.</h2>
      <p className="blog-empty-state__lead">
        We couldn&apos;t find anything with those settings. Reset to see the full blog again.
      </p>
      {onReset ? (
        <button type="button" className="primary-blue-small-btn blog-empty-state__reset" onClick={onReset}>
          Reset
        </button>
      ) : null}
    </div>
  </section>
);

export default BlogNoResults;
